import React from 'react';
import { Users, Zap, FileText, FileCheck, ShieldCheck, PlayCircle, ArrowRight } from 'lucide-react';
export const ProductWorkflow = () => {
  const steps = [{
    number: '01',
    title: 'Agencies list their roster',
    desc: 'Talent agencies add their creators to the database so they are discoverable.',
    icon: <Users size={24} className="text-zano-pink" data-id="element-1564" />
  }, {
    number: '02',
    title: 'Profiles stay current',
    desc: 'Zano updates live performance data (followers, views, engagement) automatically.',
    icon: <Zap size={24} className="text-blue-500" data-id="element-1565" />
  }, {
    number: '03',
    title: 'Brands post casting calls',
    desc: 'Specify goals, deliverables, and budget. Blasted to 400+ agencies instantly.',
    icon: <FileText size={24} className="text-purple-500" data-id="element-1566" />
  }, {
    number: '04',
    title: 'Agencies submit talent',
    desc: 'Agencies review the brief and submit their best-fit creators with custom quotes.',
    icon: <FileCheck size={24} className="text-orange-500" data-id="element-1567" />
  }, {
    number: '05',
    title: 'Connect directly',
    desc: 'Filter submissions, find the right match, and take the conversation directly to email.',
    icon: <PlayCircle size={24} className="text-green-500" data-id="element-1568" />
  }];
  return <section className="py-24 bg-white border-y border-gray-100" data-id="element-1569">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1570">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1571">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-1572">
            How Zano works
          </h2>
          <p className="text-lg text-gray-600" data-id="element-1573">
            Streamlining how you source represented talent and partner with
            talent agencies at scale.
          </p>
        </div>

        <div className="relative" data-id="element-1574">
          {/* Connecting Line */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gray-100 -z-10" data-id="element-1575"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8" data-id="element-1576">
            {steps.map((step, idx) => <div key={idx} className="relative flex flex-col items-center text-center" data-id="element-1577">
                <div className="w-24 h-24 bg-white rounded-full border-4 border-zano-blush shadow-sm flex items-center justify-center mb-6 relative z-10" data-id="element-1578">
                  <div className="absolute top-0 right-0 w-6 h-6 bg-zano-pink text-white text-xs font-bold rounded-full flex items-center justify-center transform translate-x-1 -translate-y-1" data-id="element-1579">
                    {step.number}
                  </div>
                  {step.icon}
                </div>
                <h3 className="text-base font-semibold text-gray-900 mb-3" data-id="element-1580">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-1581">
                  {step.desc}
                </p>

                {idx < steps.length - 1 && <div className="hidden md:block lg:hidden absolute top-12 -right-4 text-gray-300" data-id="element-1582">
                    <ArrowRight size={24} data-id="element-1583" />
                  </div>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};